import * as aiPioneerCert from './aiPioneerCert';
import * as dtsAkskConfig from './dtsAkskConfig';
import * as dtsAssistant from './dtsAssistant';
import * as dtsAuth from './dtsAuth';
import * as dtsCommunity from './dtsCommunity';
import * as dtsDashboard from './dtsDashboard';
import * as dtsFeedback from './dtsFeedback';
import * as dtsHomePage from './dtsHomePage';
import * as dtsNews from './dtsNews';
import * as dtsNotification from './dtsNotification';
import * as dtsOss from './dtsOss';
import * as dtsResource from './dtsResource';
import * as dtsRole from './dtsRole';
import * as dtsSearch from './dtsSearch';
import * as dtsService4Front from './dtsService4Front';
import * as dtsTraining from './dtsTraining';
import * as dtsUseCase from './dtsUseCase';
import * as dtsUseCaseNugget from './dtsUseCaseNugget';
import * as dtsUseCaseNugget4Front from './dtsUseCaseNugget4Front';
import * as dtsUser from './dtsUser';
import * as dtsVideo from './dtsVideo';
import * as login from './login';

export const dtsServer = {
  aiPioneerCert,
  dtsAkskConfig,
  dtsAssistant,
  dtsAuth,
  dtsCommunity,
  dtsDashboard,
  dtsFeedback,
  dtsHomePage,
  dtsNews,
  dtsNotification,
  dtsOss,
  dtsResource,
  dtsRole,
  dtsSearch,
  dtsService4Front,
  dtsTraining,
  dtsUseCase,
  dtsUseCaseNugget,
  dtsUseCaseNugget4Front,
  dtsUser,
  dtsVideo,
  login,
};
